import { Card, Divider } from "@towersystems/roam-common-native";
import { FlatList } from "react-native";
import { SyncProgressEvent } from "../../../../utilities/setup/page-query";
import { SyncProgressListItem } from "../SyncProgressListItem";

export interface SyncProgressTableProps {
  progressState: Record<string, SyncProgressEvent>;
}

type SyncListItemType = {
  name: string;
  progress: SyncProgressEvent;
};

export function SyncProgressTable({ progressState }: SyncProgressTableProps) {
  const renderEntityProgress = ({ item }: { item: SyncListItemType }) => {
    return <SyncProgressListItem {...item} />;
  };

  const items = [
    ...Object.entries(progressState).map(([name, progress]) => ({
      name,
      progress,
    })),
  ];

  return (
    <Card
      style={{ flex: 1, paddingTop: 0 }}
      containerStyle={{ flex: 1 }}
      filled
    >
      <FlatList
        windowSize={items.length}
        initialNumToRender={items.length}
        keyExtractor={(item) => item.name}
        ItemSeparatorComponent={() => <Divider marginVertical={0} />}
        data={items}
        renderItem={renderEntityProgress}
        style={{ maxHeight: 300 }}
      />
    </Card>
  );
}
